// Creates/deletes a real event on the signed-in user's Google Calendar via
// the Calendar API, using an access token obtained separately (see the
// `useGoogleLogin({ scope: CALENDAR_SCOPE })` call in rssfeeds.js) — a plain
// Google sign-in id token does not carry this permission.
import axios from "axios";

export const CALENDAR_SCOPE = "https://www.googleapis.com/auth/calendar.events";

const stripHtml = (html = "") => html.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();

// The post's event date is a plain calendar date (stored as UTC midnight), so
// it becomes an all-day event on that exact date. Google's all-day `end` is
// exclusive, hence the +1 day.
const buildEventPayload = (ticket) => {
  const start = new Date(ticket.eventDate);
  const end = new Date(start.getTime() + 24 * 60 * 60 * 1000);
  const toDateOnly = (date) => date.toISOString().slice(0, 10);

  return {
    summary: ticket.subject || "Campus Pulse event",
    description: `${stripHtml(ticket.description).slice(0, 400)}\n\nPost #${ticket.ticketId} — Campus Pulse, UMT`,
    start: { date: toDateOnly(start) },
    end: { date: toDateOnly(end) },
    reminders: { useDefault: true },
  };
};

export const createCalendarEvent = async (accessToken, ticket) => {
  const { data } = await axios.post(
    "https://www.googleapis.com/calendar/v3/calendars/primary/events",
    buildEventPayload(ticket),
    { headers: { Authorization: `Bearer ${accessToken}` } }
  );
  return data.id;
};

export const deleteCalendarEvent = async (accessToken, eventId) => {
  await axios.delete(`https://www.googleapis.com/calendar/v3/calendars/primary/events/${eventId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
};
